import { render, staticRenderFns } from "./SendFilesToContacts.vue?vue&type=template&id=4df5e189&"
import script from "./SendFilesToContacts.vue?vue&type=script&lang=js&"
export * from "./SendFilesToContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports